export class SnackbarModel {
  constructor(type, message) {
    this.model = false;
    this.type = type;
    this.message = message;
  }
}

export const SNACKBAR_MESSAGES = {
  SUBTITLES_LOAD_SUCCESSFUL:     'Subtitles has been loaded',
  USER_SUBTITLES_ALREADY_LOADED: 'Subtitles already loaded',
  USER_SUBTITLES_LOAD_FAILED:    'Subtitles failed to load',
  invalidFileType:               (videoPath) => `${videoPath} invalid file type`,
  invalidSidecarAudio:           (sidecarAudioPaths) => `${sidecarAudioPaths.join(', ')} invalid sidecar audio`,
  videoLoaded:                   (videoPath) => `Video ${videoPath} has been loaded`,
  videoAndAudioLoaded:           (videoPath, sidecarAudioPaths) =>
    `Video ${videoPath} with audio: ${sidecarAudioPaths.join(', ')} has been loaded`,
  SESSION_LIMIT:                    'Session limit reached',
  NOT_LICENSED:                     'System is not licensed',
  NOT_ABLE_TO_LOAD_VIDEO_FROM_PATH: 'Not able to load video from path',
  passMessage:                      (message) => `${message}`,
  unauthorized:                     (videoPath) => `User is not authorized to access ${videoPath}`,
  NOT_ABLE_TO_CLOSE_REMOTE_SESSION: 'Not able to close remote session',
};

export const SNACKBAR_NAMES = {
  SUBTITLES_LOAD_SUCCESSFUL:        'SUBTITLES_LOAD_SUCCESSFUL',
  USER_SUBTITLES_ALREADY_LOADED:    'USER_SUBTITLES_ALREADY_LOADED_SNACKBAR',
  USER_SUBTITLES_LOAD_FAILED:       'USER_SUBTITLES_LOAD_FAILED',
  INVALID_FILE_TYPE:                'INVALID_FILE_TYPE',
  VIDEO_LOADED:                     'VIDEO_LOADED',
  SESSION_LIMIT:                    'SESSION_LIMIT',
  NOT_LICENSED:                     'NOT_LICENSED',
  UNAUTHORIZED:                     'UNAUTHORIZED',
  ERROR:                            'ERROR',
  SESSION_START_FAIL:               'SESSION_START_FAIL',
  SIDECAR_AUDIO_INVALID:            'SIDECAR_AUDIO_INVALID',
  NOT_ABLE_TO_CLOSE_REMOTE_SESSION: 'NOT_ABLE_TO_CLOSE_REMOTE_SESSION',
};

export const SNACKBAR_TYPE = {
  SUCCESS: 'green',
  ERROR:   'red',
};

export const SNACKBARS = new Map([
  [
    SNACKBAR_NAMES.SUBTITLES_LOAD_SUCCESSFUL,
    new SnackbarModel(SNACKBAR_TYPE.SUCCESS, SNACKBAR_MESSAGES.SUBTITLES_LOAD_SUCCESSFUL),
  ],
  [
    SNACKBAR_NAMES.USER_SUBTITLES_ALREADY_LOADED,
    new SnackbarModel(SNACKBAR_TYPE.ERROR, SNACKBAR_MESSAGES.USER_SUBTITLES_ALREADY_LOADED),
  ],
  [
    SNACKBAR_NAMES.USER_SUBTITLES_LOAD_FAILED,
    new SnackbarModel(SNACKBAR_TYPE.ERROR, SNACKBAR_MESSAGES.USER_SUBTITLES_LOAD_FAILED),
  ],
  [SNACKBAR_NAMES.INVALID_FILE_TYPE, new SnackbarModel(SNACKBAR_TYPE.ERROR, null)],
  [SNACKBAR_NAMES.VIDEO_LOADED, new SnackbarModel(SNACKBAR_TYPE.SUCCESS, null)],
  [SNACKBAR_NAMES.SESSION_LIMIT, new SnackbarModel(SNACKBAR_TYPE.ERROR, SNACKBAR_MESSAGES.SESSION_LIMIT)],
  [SNACKBAR_NAMES.NOT_LICENSED, new SnackbarModel(SNACKBAR_TYPE.ERROR, SNACKBAR_MESSAGES.NOT_LICENSED)],
  [SNACKBAR_NAMES.UNAUTHORIZED, new SnackbarModel(SNACKBAR_TYPE.ERROR, null)],
  [SNACKBAR_NAMES.SESSION_START_FAIL, new SnackbarModel(SNACKBAR_TYPE.ERROR, null)],
  [SNACKBAR_NAMES.SIDECAR_AUDIO_INVALID, new SnackbarModel(SNACKBAR_TYPE.ERROR, null)],
  [
    SNACKBAR_NAMES.NOT_ABLE_TO_CLOSE_REMOTE_SESSION,
    new SnackbarModel(SNACKBAR_TYPE.ERROR, SNACKBAR_MESSAGES.NOT_ABLE_TO_CLOSE_REMOTE_SESSION),
  ],
]);
